<div class="actions-grid">
    <ng-container *ngFor="let action of actions">
        <a class="action-card">
            <img class="action-icon" [src]="action.icon" alt="">
            <h3 class="action-title">{{action.title}}</h3>
            <p class="action-description">
                {{action.description}}
            </p>
            <div class="action-link">
                <a class="action-link-card" (click)="goToAction(action)" (keydown.enter)="goToAction(action)">
                    <span>{{action.nameButton}}</span>
                    <img src="../assets/icons/arrow_forward.svg" alt="">
                </a>
            </div>
        </a>
    </ng-container>
</div>